export var FS_ANNOUNCEMENTS;
(function (FS_ANNOUNCEMENTS) {
    FS_ANNOUNCEMENTS["LOGIN"] = "login";
    FS_ANNOUNCEMENTS["MAINTENANCE"] = "maintenance";
})(FS_ANNOUNCEMENTS || (FS_ANNOUNCEMENTS = {}));
export var ANNOUNCEMENTS_CONFIG = [
    FS_ANNOUNCEMENTS.LOGIN,
    FS_ANNOUNCEMENTS.MAINTENANCE,
];
